/* Kaleo add-all-to-cart (KW-046): one click adds every figure in the
   band's data-variants list (built server-side from the collection's
   available products), then lands on /cart — where the pre-order
   notice and shipping tiers present the full set. Only rendered in
   live commerce mode. */
(() => {
  class KaleoAddAll extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-kaleo-add-all-button]');
      this.error = this.querySelector('[data-kaleo-add-all-error]');
      if (!this.button) return;
      let variants = [];
      try {
        variants = JSON.parse(this.dataset.variants || '[]');
      } catch (e) {
        variants = [];
      }
      if (!Array.isArray(variants) || variants.length === 0) {
        this.button.disabled = true;
        return;
      }
      this.items = variants.map((id) => ({ id: Number(id), quantity: 1 }));
      this.button.addEventListener('click', () => this.addAll());
    }

    async addAll() {
      this.button.disabled = true;
      this.button.classList.add('loading');
      if (this.error) this.error.hidden = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: this.items }),
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Could not add the set to the cart.');
        }
        window.location.href = window.Shopify && window.Shopify.routes
          ? `${window.Shopify.routes.root}cart`
          : '/cart';
      } catch (err) {
        this.button.disabled = false;
        this.button.classList.remove('loading');
        if (this.error) {
          this.error.textContent = err.message;
          this.error.hidden = false;
        }
      }
    }
  }

  if (!customElements.get('kaleo-add-all')) {
    customElements.define('kaleo-add-all', KaleoAddAll);
  }
})();
